import { gsap, Power2, Power4 } from 'gsap'

class MvAnimation {
  constructor(el) {
    this.dom = {el: el};
    this.dom.images = this.dom.el.querySelectorAll('[data-image]')
    this.dom.copy = document.querySelectorAll('[data-js="visual-copy"]')
    this.dom.text = document.querySelectorAll('[data-js="visual-text"]')
    this.dom.navigation = document.querySelectorAll('[data-js="visual-navigation"]')
    this.dom.entries = document.querySelectorAll('[data-js="visual-entries"]')
    this.dom.banner = document.querySelectorAll('[data-js="visual-banner"]')

    this.path = {
      open: 'polygon(-20% -20%, 120% -20%, 120% 120%, -20% 120%)',
      close: 'polygon(-20% -20%, -20% -20%, -20% 120%, -20% 120%)'
    }

    this.init();
  }

  init() {
    // gsap.set(this.dom.header, {
    //   y: `-100%`
    // });
    // gsap.set(this.dom.trigger, {
    //   y: `-100%`
    // });

    [...this.dom.images].forEach((el, index, array) => {
      gsap.to(el, {
        opacity: 1,
        duration: 1.2,
        delay: .15 * index,
        ease: Power2.easeInOut,
        onComplete: () => {
          if (index >= array.length - 1) {
            document.body.style.setProperty('--animation-val', '0');
            document.body.style.setProperty('--animation-val-bottom', '0');

            gsap.fromTo(this.dom.copy, {
              clipPath: this.path.close,
            }, {
              clipPath: this.path.open,
              duration: .9,
              delay: .3,
              ease: Power4.easeInOut,
              onComplete: () => {
                gsap.set(this.dom.copy, {
                  clipPath: 'none',
                })
              }
            })

            gsap.fromTo(this.dom.text, {
              clipPath: this.path.close,
            }, {
              clipPath: this.path.open,
              duration: .9,
              delay: .4,
              ease: Power4.easeInOut,
            })

            gsap.to(this.dom.navigation, {
              opacity: 1,
              y: 0,
              duration: 1.2,
              delay: .6,
              ease: Power4.easeInOut,
            })

            gsap.to(this.dom.banner, {
              opacity: 1,
              y: 0,
              duration: 1.2,
              delay: .6,
              ease: Power4.easeInOut,
            })
          }
        }
      })
    });
  }
}

export default MvAnimation